<script>
  import {Bar} from 'vue-chartjs'

  export default {
    extends: Bar,
    name: "payments",
    mounted() {
      // Overwriting base render method with actual data.
      this.renderChart({
        labels: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь'],
        datasets: [
          {
            backgroundColor: '#c066da',
            data: [0, 0, 0, 11.2, 15.6, 0]
          }
        ]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          labels: {
            fontColor: 'rgb(255, 99, 132)'
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display:false
              }
            }
          ],
          yAxes: [
            {
              display:false,
              gridLines: {
                drawBorder: false,
                scaleShowLabels: false,
              }
            }
          ]
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Payments.vue